import React from "react";
import { IconButton, InputAdornment, TextField, TextFieldProps, Tooltip } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

/** TextField for passwords with a show/hide toggle. Accepts every normal TextField prop. */
const PasswordField: React.FC<TextFieldProps> = (props) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <TextField
      {...props}
      type={visible ? "text" : "password"}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={visible ? "Hide password" : "Show password"}>
              <IconButton
                edge="end"
                size="small"
                aria-label={visible ? "Hide password" : "Show password"}
                onClick={() => setVisible((v) => !v)}
                onMouseDown={(e) => e.preventDefault()}
                tabIndex={-1}
              >
                {visible ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordField;
